import { Link } from "react-router-dom";

const RULES = [
  { n: "01", t: "PAIN IS TEMPORARY", b: "Legacy is forever. We don't build for trends — we build for the kids who outlast them." },
  { n: "02", t: "DISCIPLINE OVER EVERYTHING", b: "Talent gets you in the door. Discipline keeps you in the room. We dress the second kind." },
  { n: "03", t: "TRUST NO ONE", b: "Not influencers, not algorithms, not your fake friends. The street will tell you the truth." },
  { n: "04", t: "EXPECT NOTHING", b: "Nobody owes you a thing. Want a seat? Pull up a chair. Want a chain? Earn the link." },
  { n: "05", t: "STAY DANGEROUS", b: "Soft kids fold first. Sharpen yourself daily. Be the headline they didn't see coming." },
];

export default function Manifesto() {
  return (
    <div data-testid="manifesto-page" className="bg-ink">
      {/* Hero */}
      <section className="border-b border-white/20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-24 sm:py-32">
          <p className="text-blood text-xs tracking-[0.4em] font-mono mb-4">// THE CODE</p>
          <h1 className="font-anton uppercase text-bone text-6xl sm:text-8xl lg:text-9xl tracking-tighter leading-[0.85]">
            FIVE RULES.<br/>
            NO <span className="text-blood">EXCEPTIONS</span>.
          </h1>
          <p className="font-marker text-bone text-2xl sm:text-3xl mt-6 max-w-2xl">
            you don't wear toxic street. you live it.
          </p>
        </div>
      </section>

      {/* The rules */}
      <section className="border-b border-white/20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {RULES.map((r) => (
            <article
              key={r.n}
              data-testid={`manifesto-rule-${r.n}`}
              className="grid grid-cols-12 gap-4 py-12 border-t border-white/10 first:border-t-0 group"
            >
              <div className="col-span-2 lg:col-span-1">
                <span className="font-anton text-blood text-5xl sm:text-7xl tracking-tighter">{r.n}</span>
              </div>
              <div className="col-span-10 lg:col-span-7">
                <h2 className="font-anton uppercase text-bone text-3xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.9] group-hover:text-blood transition-colors">
                  {r.t}
                </h2>
              </div>
              <div className="col-span-12 lg:col-span-4 text-bone text-sm sm:text-base leading-relaxed font-mono">
                {r.b}
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="bg-ink py-24 text-center px-4">
        <p className="font-marker text-blood text-4xl sm:text-5xl">if you read this, you're already in.</p>
        <Link
          to="/shop"
          data-testid="manifesto-shop-link"
          className="inline-block mt-10 px-10 py-5 bg-blood text-bone text-xs tracking-[0.4em] uppercase font-mono hover:bg-bone hover:text-ink transition-colors"
        >
          ENTER THE DROP →
        </Link>
      </section>
    </div>
  );
}
